import { ComponentRenderer } from './ReportCanvas';
import { GRID_STYLE, gridBottom, gridItemStyle, gridRowsHeight } from './grid';
import type { GridLayout } from './types';

/**
 * Read-only renderer for a canvas layout: its items on the Report grid with
 * live components, but no dnd-kit machinery, hover toolbars, handles or
 * config popovers. This is what pages mount for every viewer (and what a
 * Report's PDF captures, one grid band at a time); the full editing canvas
 * mounts only while customizing. Requires the registry + data contexts.
 */
export function ReportCanvasView({ layout }: { layout: GridLayout }) {
  return (
    <div
      className="w-full"
      style={{ ...GRID_STYLE, height: gridRowsHeight(gridBottom(layout)) }}
    >
      {layout.map((item) => (
        <div
          key={item.id}
          style={gridItemStyle(item)}
          className="flex flex-col overflow-hidden rounded-md"
        >
          <ComponentRenderer component={item.component} />
        </div>
      ))}
    </div>
  );
}
